import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 30rem;
  width: 55rem;
  flex-direction: column;
  border-radius: 6px;
  > div:nth-child(1){
    display: flex;
    height: 3rem;
    justify-content: center;
    align-items: center;
    padding: 0 .5rem 0 .5rem;
    > input {
      outline: none;
      width: 100%;
      height: 2.5rem;
      padding: 5px 12px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 6px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgb(236, 236, 236);
      pointer-events: auto;
      color: rgb(73, 80, 87);
    }
  }
  > div:nth-child(2){
    width: 100%;
    height: 100%;
    max-height: calc(30rem - 3rem);
  }
`;